import styled from "styled-components";

export const GridBox = styled.div`
  gap: 8px;
  width: 100%;
  height: auto;
  display: flex;
  overflow: auto;
  max-height: calc(80vh - 200px);
  flex-direction: column;
`;
